import React, { FC, useRef } from "react";
import { MotifTreeNode } from "./BaseTree/treeNode";

type TreeNodeProps = {
  className?: string;
  value?: any;
  icons?: any;
  children?: React.ReactNode;
  defaultExpandAll?: boolean;
  expandAll?: boolean;
  open?: boolean;
};
const TreeNode: FC<TreeNodeProps> = ({
  className,
  value,
  icons,
  defaultExpandAll,
  expandAll,
  open,
  ...other
}: TreeNodeProps) => (
  <MotifTreeNode
    className={className}
    value={value}
    icons={icons}
    defaultExpandAll={defaultExpandAll}
    open={open}
    {...other}
  />
);
export default TreeNode;
